<template>
  <main class="c-main">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <header class="card-header d-flex justify-content-between">
            <div>
              <button
                class="btn mr-1"
                :class="{
                  'btn-secondary': filter.status === null,
                  'btn-primary': filter.status !== null,
                }"
                @click="changeFilter({ status: null })"
              >
                Все
              </button>
              <button
                class="btn mr-1"
                :class="{
                  'btn-secondary': filter.status === 0,
                  'btn-info': filter.status !== 0,
                }"
                @click="changeFilter({ status: 0 })"
              >
                Требующие действия
              </button>
              <button
                class="btn mr-1"
                :class="{
                  'btn-secondary': filter.status === 1,
                  'btn-success': filter.status !== 1,
                }"
                @click="changeFilter({ status: 1 })"
              >
                Подтвержденные
              </button>
              <button
                class="btn mr-2"
                :class="{
                  'btn-secondary': filter.status === 2,
                  'btn-danger': filter.status !== 2,
                }"
                @click="changeFilter({ status: 2 })"
              >
                Отмененные
              </button>
            </div>
            <h4 class="pull-right">Действия пользователей</h4>
          </header>
          <div class="card-body">
            <div class="row mb-3">
              <div class="col-md-4">
                <v-select
                  label="name"
                  :options="users"
                  :reduce="(user) => user.id"
                  v-model="filter.user_id"
                  @input="handleUserFilter"
                  placeholder="Выберите пользователя"
                ></v-select>
              </div>
              <div class="col-md-4">
                <v-select
                  :options="comments"
                  v-model="filter.comment"
                  @input="handleUserFilter"
                  placeholder="Выберите действие"
                >
                  <template #option="option">
                    <div
                      class="p-2"
                      :class="getActionClass(option.label || option)"
                    >
                      {{ option.label || option }}
                    </div>
                  </template>
                </v-select>
              </div>
              <div class="d-flex col-md-4">
                <div class="form-group mr-4 flex-grow-1">
                  <input
                    type="text"
                    class="form-control"
                    v-model="filter.code"
                    placeholder="Код"
                  />
                </div>
                <div class="form-group">
                  <button class="btn btn-success" @click="handleUserFilter">
                    Фильтр
                  </button>
                </div>
              </div>
            </div>

            <div class="d-flex justify-content-center">
              <paginate
                v-model="filter.page"
                :page-count="filter.count"
                :page-range="3"
                :margin-pages="2"
                :click-handler="getCurrentPage"
                :prev-text="'<'"
                :next-text="'>'"
                :container-class="'pagination'"
                :page-class="'page-item'"
                :page-link-class="'page-link-item'"
                :prev-class="'prev-pagination'"
                :prev-link-class="'prev-link-pagination'"
                :next-class="'next-pagination'"
                :next-link-class="'next-link-pagination'"
              ></paginate>
            </div>
            <table
              class="table table-bordered table-striped"
              id="serverDataTable"
            >
              <thead>
                <tr>
                  <th>id</th>
                  <th>Пользователь</th>
                  <th>Коментарий к действию</th>
                  <th>Подтверждено</th>
                  <th>Код</th>
                  <th>Время отправки на утверждение</th>
                  <th>Действие</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(val, index) in actions"
                  :key="index"
                  :class="getActionClass(val.action.action)"
                >
                  <td>{{ val.id }}</td>
                  <td>{{ val.action.user.name }}</td>
                  <td>
                    {{ val.action.action + " - " + val.action.created_at }}
                  </td>
                  <td>{{ val.user.name }} - {{ val.verified_at }}</td>
                  <td>{{ val.action.code }}</td>
                  <td>{{ formatDateTime(val.sent_for_verification_at) }}</td>

                  <td>
                    <button
                      class="btn btn-primary mr-1"
                      @click="
                        changeModalData(
                          val.route.action.as.split('.'),
                          index,
                          val.status,
                          val.comment
                        )
                      "
                    >
                      посмотреть
                    </button>
                    <button
                      v-if="val.status === 0"
                      class="btn btn-success"
                      @click="acceptAction(val.id)"
                    >
                      Подтвердить
                    </button>
                    <button
                      v-if="val.status === 0"
                      class="btn btn-danger mr-1"
                      @click="changeModalData(['cancel'], index)"
                    >
                      отменить
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="row d-flex justify-content-center">
            <paginate
              v-model="filter.page"
              :page-count="filter.count"
              :page-range="3"
              :margin-pages="2"
              :click-handler="getCurrentPage"
              :prev-text="'<'"
              :next-text="'>'"
              :container-class="'pagination'"
              :page-class="'page-item'"
              :page-link-class="'page-link-item'"
              :prev-class="'prev-pagination'"
              :prev-link-class="'prev-link-pagination'"
              :next-class="'next-pagination'"
              :next-link-class="'next-link-pagination'"
            ></paginate>
          </div>
        </div>
      </div>
    </div>
    <renderModel
      :modalData="modalData"
      :actions="actions"
      @update="updateFromModels"
    ></renderModel>
  </main>
</template>

<script>
import { GET, POST } from "@/shared/api";
import request_data from "@/views/validateAction/requestView/request_data";
import renderModel from "@/views/validateAction/requestView/renderModel";
import { formatDateTime } from "@/shared/utils";

const comments = [
  "Добавление класса",
  "Изменение класса",
  "Удаление класса",
  "Добавление свойства",
  "Изменение свойства",
  "Удаление свойства",
  "Удаление категории",
  "Изменение категории",
  "Создание категории",
  "Переведено",
];
export default {
  components: { request_data, renderModel },
  data() {
    return {
      modalData: {},
      actions: [],
      users: [],
      confirmation: false,
      formatDateTime,

      filter: {
        status: 0,
        mode: 0,
        page: 1,
        perpage: 10,
        count: 0,
        code: null,
        user_id: null,
        comment: null,
      },
      comments: comments,
      actionColors: {
        "Добавление класса": "bg-action-1",
        "Изменение класса": "bg-action-2",
        "Удаление класса": "bg-action-3",
        "Добавление свойства": "bg-action-4",
        "Изменение свойства": "bg-action-5",
        "Удаление свойства": "bg-action-6",
        "Удаление категории": "bg-action-7",
        "Изменение категории": "bg-action-8",
        "Создание категории": "bg-action-9",
        Переведено: "bg-action-10",
      },
      totalCount: 0,
    };
  },
  methods: {
    updateFromModels(state) {
      if (typeof state === "object") {
        switch (state.action) {
          case "gAA":
            this.getActiveActions();
            break;
        }
      }
    },
    changeModalData(route, index, status, comment) {
      this.modalData = {
        route: route,
        index: index,
        status: status,
        comment: comment,
      };
    },
    changeFilter(filter) {
      let changed = false;
      if (typeof filter.status !== "undefined") {
        this.filter.status = filter.status;
        changed = true;
      }
      if (typeof filter.perpage !== "undefined") {
        this.filter.perpage = filter.perpage;
        changed = true;
      }

      if (changed) {
        this.filter.page = 1;
        this.getActiveActions();
      }
    },
    getActiveActions() {
      const params = { ...this.filter };
      if (!params.user_id) delete params.user_id;
      if (!params.comment) delete params.comment;
      if (!params.code) delete params.code;

      GET(params, "/validate-actions/query", this, false).then((response) => {
        let result = response.data.data;

        this.totalCount = response.data.total;
        this.filter.count = Math.ceil(this.totalCount / this.filter.perpage);

        result.forEach((val, index) => {
          val.request_data = JSON.parse(val.request_data);
          val.route = JSON.parse(val.route);
          if (typeof val.user == "undefined" || val.user == null) {
            val.user = {
              name: null,
            };
          }

          if (typeof val.action === "undefined" || val.action === null) {
            val.action = {
              action: null,
              user: {
                name: null,
              },
            };
          }
        });
        this.actions = result;
      });
    },
    acceptAction(validateAction_id) {
      POST(
        { mode: 1, id: validateAction_id, comment: "accepted!" },
        "/validate-actions/action",
        this,
        true
      ).then((response) => {
        this.getActiveActions();
      });
    },
    getCurrentPage(pageNumber) {
      this.filter.page = pageNumber;
      this.getActiveActions();
    },

    handleUserFilter() {
      this.filter.page = 1;
      this.getActiveActions();
    },

    getUsers() {
      GET({ append: ["roles"] }, "/user", this, false).then((response) => {
        console.log("response", response);
        // this.users = response;
        response.forEach((user) => {
          if (user.roles.includes("user")) {
            this.users.push(user);
          }
        });
        // this.users = response?.filter((user) => user?.roles?.includes("user"));
      });
    },
    getActionClass(actionName) {
      if (!actionName) return "";
      const name =
        typeof actionName === "object" ? actionName.label : actionName;

      // Find the key in actionColors that the name starts with
      const key = Object.keys(this.actionColors).find((k) =>
        name.startsWith(k)
      );
      return key ? this.actionColors[key] : "";
    },
  },

  mounted() {
    this.getActiveActions();
    this.getUsers();
  },
};
</script>

<style scoped>
.bg-action-1 {
  background-color: #bbdefb !important;
}
.bg-action-2 {
  background-color: #c8e6c9 !important;
}
.bg-action-3 {
  background-color: #ffcdd2 !important;
}
.bg-action-4 {
  background-color: #fff9c4 !important;
}
.bg-action-5 {
  background-color: #e1bee7 !important;
}
.bg-action-6 {
  background-color: #ffe0b2 !important;
}
.bg-action-7 {
  background-color: #b2dfdb !important;
}
.bg-action-8 {
  background-color: #c5cae9 !important;
}
.bg-action-9 {
  background-color: #d7ccc8 !important;
}
.bg-action-10 {
  background-color: #f8bbd0 !important;
}

::v-deep .vs__dropdown-option--highlight {
  background: transparent !important;
  color: inherit;
}
</style>
